<section class="breadcrumbs-placeholder">
</section>
<section class="index h-75 d-flex">
  <div class="container container-index">
    <div class="row justify-content-around align-content-center art-group h-75">
      <app-booking-event-area-item-slot class="col-12 col-md-4 pb-4"
        *ngFor="let eventAreaItemSlot of eventAreaItemSlots" [eventAreaItemSlot]="eventAreaItemSlot"
        (eventAreaItemSelected)="onEventAreaItemSlotSelected($event)" [maxLenNameSlot]="maxLenNameSlot"
        [quantityLetterInSlot]="quantityLetterInSlot">
      </app-booking-event-area-item-slot>
    </div>
  </div>
</section>
